<template>
    <div>
        <el-button id="start_crawl_button" :type="button_type" style="margin-top:20px" v-on:click="storeIfNeededThenCrawl">Start Crawling</el-button>

        <el-button @click="openDefDialog" icon="el-icon-setting"></el-button>

        <el-dialog
                title="Preflight Issues"
                :visible.sync="should_show_preflight_override_dialog"
        >
            <div :style="'margin-bottom:20px;padding:10px;background-color:'+preflight_bg">{{preflight_response.status}}</div>
            <div>
                <ul>
                    <li v-for="error in preflight_response.errors">{{error.text}}</li>
                </ul>
            </div>
            <el-button :style="'background-color:'+preflight_bg" @click="startCrawl(true)">Continue anyway</el-button>
            <el-button>Stop</el-button>

        </el-dialog>

        <el-dialog
                title="Crawl Definition"
                :visible.sync="show_definition">

            <el-radio v-model="selected_definition_type" label="global default">Content Chimera Default</el-radio>
            <el-radio v-if="extent_definition" v-model="selected_definition_type" label="extent default">Site Default</el-radio>
            <el-radio v-if="last_definition" v-model="selected_definition_type" label="job specific">Last Crawl</el-radio>
            <el-radio v-model="selected_definition_type" label="new config">New Config</el-radio>

            <FormManager
                    @use="use"
                    @saveAsDefault="saveAsDefault"
                    @cancelDialog="cancelDialog"
                    @onModify="onModify"
                    :initialFormValues="selected_definition_definition"
                    :events="events"
                    :prettyEndPoint="prettyEndPoint" />

        </el-dialog>


    </div>
</template>

<script>
    import ElOption from "../../../../node_modules/element-ui/packages/select/src/option.vue";
    import CrawlAttribute from "./CrawlAttribute";
    import ExtentList from '../old/ExtentListOld.vue'

    export default {
        props: ['selected_extent','button_type'],
        components: {CrawlAttribute, ElOption},
        mounted() {
          this.getDefinitions()
        },
        computed: {
            preflight_bg: function() {
              return (this.preflight_response.status === 'warning') ? 'yellow' : 'red'
            },
            selected_definition_definition: function() {
                if (this.selected_definition) {
                    return this.selected_definition.definition
                } else {
                    return null
                }
            }
        },
        watch: {
            selected_extent: function() {
              this.getDefinitions()
            },
            selected_definition_type: function(val) {
                if (val === 'global default') {
                    this.selected_definition = JSON.parse(JSON.stringify(this.global_definition))
                } else if (val === 'job specific') {
                    this.selected_definition = JSON.parse(JSON.stringify(this.last_definition))
                } else if (val === 'extent default') {
                    this.selected_definition = JSON.parse(JSON.stringify(this.extent_definition))
                }
                // If this is the first time we're setting the selected definition, then also make this the committed definition
                if(this.committed_definition===null) {
                    this.committed_definition = JSON.parse(JSON.stringify(this.selected_definition))
                }
            },
        },
        data() {
            return {
                should_show_preflight_override_dialog: false,
                preflight_response: {status: '',errors: []},
                extents: '',
                show_definition: false,
                crawl_attributes_map: null,
                crawl_definitions: null,
                // This is the definition as committed by the user (for instance, but clicking "Use for this crawl")
                committed_definition: null,
                // The type a user has specifically selected (but perhaps hasn't clicked the button to actually use it,
                // so these should be treated as tentative values)
                selected_definition_type: null,
                selected_definition: null,
                // If the user doesn't make a change, what's (best) default
                best_default_definition_type: null,
                best_default_definition: null,
                // The various potential definitions
                global_definition: null,
                extent_definition: null,
                last_definition: null,
                new_definition: null,
                prettyEndPoint: null,
                events: {
                    use: {
                        label: "Use for this crawl" ,
                        event: "use"
                    },
                    saveAsDefault: {
                        label: "Save as site defaults (and use)",
                        event: "saveAsDefault"
                    },
                    cancel: {
                        label: "Cancel",
                        event: "cancel"
                    }
                },
                fields_to_null_on_form_update: ['id','created_at','updated_at'],
            }
        },
        methods: {
            getDefinitions() {
              if (this.selected_extent) {
                this.prettyEndPoint = '/api/utilities/pretty_crawl_definition_map/' + this.selected_extent
                axios.get('/extents/get_all_crawl_definitions/' + this.selected_extent)
                    .then(response => {
                      this.crawl_definitions = response.data
                      this.crawl_definitions.forEach((definition) => {
                        if (definition.type.label === 'global default') {
                          this.global_definition = definition
                        } else if (definition.type.label === 'job specific') {
                          this.last_definition = definition
                        } else if (definition.type.label === 'extent default') {
                          this.extent_definition = definition
                        }
                      })
                      if (this.extent_definition) {
                        this.best_default_definition = this.extent_definition
                        this.best_default_definition_type = 'extent default'
                      } else {
                        this.best_default_definition = this.global_definition
                        this.best_default_definition_type = 'global default'
                      }
                      this.selected_definition_type = this.best_default_definition_type
                    })
                    .catch(error => {
                      console.log('could not load crawl definitions')
                    })
              }
            },
            saveAsDefault(values,is_modified) {
                this.selected_definition.definition = values
                if (is_modified) {
                    this.selected_definition_type = 'new config'
                    delete this.selected_definition.definition.id
                    delete this.selected_definition.definition['created_at']
                    delete this.selected_definition.definition['updated_at']
                }
                this.committed_definition = JSON.parse(JSON.stringify(this.selected_definition))
                axios.post('/api/crawl_definition', {
                    definition: this.committed_definition.definition
                }).then(response => {
                    this.committed_definition.definition.id = response.data
                    axios.post('/extents/default_crawl_definition/' + this.selected_extent, {
                        definition: this.committed_definition.definition
                    }).then(response => {
                        this.committed_definition.definition.id = response.data
                    }).catch(error => {
                        console.log('could not store new extent definition (b)')
                        console.log(error.response)
                    })
                }).catch(error => {
                    console.log('could not store new extent definition (a)')
                    console.log(error.response)
                })
                this.show_definition = false
                // Remember we may not have even had an extent definition until we are saving it here -- we need to write this into the extent_definition object so it can be displayed in the UI the next time the definition dialog is brought up
                this.extent_definition =  JSON.parse(JSON.stringify(this.selected_definition))
                this.committed_definition =  JSON.parse(JSON.stringify(this.selected_definition))
                this.selected_definition_type = 'extent default'
            },
            storeIfNeededThenCrawl() {
                if (!this.committed_definition.definition.id) {
                    axios.post('/api/crawl_definition', {
                        definition: this.committed_definition.definition
                    }).then(response => {
                        this.committed_definition.definition.id = response.data
                        this.startCrawl()
                    }).catch(error => {
                        console.log('could not store crawl definition')
                        console.log(error.response)
                    })
                } else {
                    console.log(this.committed_definition.definition.id)
                    this.startCrawl()
                }
            },
            startCrawl(override=false) {
                console.log('in startCrawl()')
                let options = {
                    extent_id: this.selected_extent,
                    data_source_id: 1, // hack: this depends on the inventory captain crawler being id = 1, which depends on the seeder
                    crawl_definition_id: this.committed_definition.definition.id,
                    type: "crawl",
                    override: override,
                }
                axios.post('/api/jobChains/preflight', options).then(response => {
                    this.preflight_response = response.data
                    if (override || (this.preflight_response.status==='ready')) {
                        axios.post('/api/jobChains', options).then(response => {
                            console.log('here comes the response from starting the jobchain')
                            console.log(response)
                            window.location.href = '/progress/' + response.data.job_chain_id
                        }).catch(error => {
                            console.log('oops problem starting scrape job')
                            console.log(error.response)
                        })
                    } else if (this.preflight_response.status==='warning') {
                        this.should_show_preflight_override_dialog = true
                    } else {
                        this.should_show_preflight_override_dialog = true
                        console.log('not going to continue to crawl')
                        console.log(response.data)
                    }
                }).catch(error => {
                    console.log('oops getting preflight info')
                    console.log(error.response)
                })
            },
            handleCheckChangeParent(selected_extent) {
                this.selected_extent = selected_extent.id
            },
            openDefDialog() {
                this.show_definition = true
            },
            onModify() {
              this.selected_definition_type = 'new config'
            },
            cancelDialog() {
                console.log('in cancelDialog() function')

                this.selected_definition = this.best_default_definition
                this.selected_definition_type = this.best_default_definition_type
                this.show_definition = false
            },
            use() {
                console.log('in use() function')
                this.selected_definition = payload.definition
                if (payload.is_modified) {
                    this.selected_definition_type = 'new config'
                    delete this.selected_definition.definition.id
                    delete this.selected_definition.definition['created_at']
                    delete this.selected_definition.definition['updated_at']
                }
                this.show_definition = false
                this.committed_definition = JSON.parse(JSON.stringify(this.selected_definition))
            },
        }
    }
</script>